module.exports = __webpack_public_path__ + "d19c09aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Pediatria/24569.jpg
// module id = 1323
// module chunks = 0 1